import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { color, motion, transform, useInView } from "framer-motion";
import Link from "../../components/v2/Link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import clsx from "clsx";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/user-based-tools/emailIntegration/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/user-based-tools/emailIntegration/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/user-based-tools/emailIntegration/images/compareItemImg5.png";

import swiperIcon1 from "../../images/v4/user-based-tools/emailIntegration/icons/swiperIcon1.svg";
import swiperIcon2 from "../../images/v4/user-based-tools/emailIntegration/icons/swiperIcon2.svg";
import swiperIcon3 from "../../images/v4/user-based-tools/emailIntegration/icons/swiperIcon3.svg";
import swiperIcon4 from "../../images/v4/user-based-tools/emailIntegration/icons/swiperIcon4.svg";

import growingIcon1 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon5.svg";
import growingIcon6 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon6.svg";
import growingIcon7 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon7.svg";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import benefitSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/benefitSectionBg.png";
import flipSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/flipSectionBg.png";
import heroSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/heroSectionBg.png";
import heroSectionImg from "../../images/v4/user-based-tools/emailIntegration/images/heroSectionImg.webp";
import swiperCardBg from "../../images/v4/user-based-tools/emailIntegration/images/swiperCardBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";

import flipImg1 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg1.webp";
import flipImg2 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg2.webp";
import flipImg3 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg3.webp";

import tabIcon1 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon1.svg";
import tabIcon2 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon2.svg";
import tabIcon3 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon3.svg";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
    backgroundImage: `url(${heroSectionBg})`,
    "& $aiSectionLeft": {
      width: "53%",
      gap: "25px",
    },
    "& .countryHighlight": {
      background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .buttonContaienr": {
      marginTop: "20px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "0px",
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "& $aiSectionLeft": {
        width: "100%",
        gap: "16px",
        "&  .wpLogo": {
          width: "40px",
          height: "40px",
          position: "relative",
          top: "10px",
        },
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
      "& .buttonContaienr": {
        marginTop: "10px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    // "&  .wpLogo": {
    //   width: "40px",
    //   height: "40px",
    //   position: "relative",
    //   top: "10px",
    // },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    width: "100%",
    flexWrap: "wrap",
    // flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minWidth: "100%",
      gap: "8px",
      marginTop: "0",
    },
  },
  listItem: {
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid rgba(241, 223, 255, 0.40)",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {},
    // color: "#A2BED3",
  },
  flipSection: {
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${flipSectionBg})`,
    "& .centerContainer": {
      width: "80%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .stackWrapper": {
      height: "700px",
      marginTop: "20px",
      "@media only screen and (max-width: 600px)": {
        height: "950px",
        marginTop: "20px",
      },
    },
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "48px 0",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      overflow: "auto",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  flipTopHeader: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "0 auto",
    textAlign: "center",
  },
  tab: {
    cursor: "pointer",
    gap: "10px",
    width: "32%",
    display: "flex",
    justifyContent: "center",
    padding: "20px 20px",
    alignItems: "center",
    borderRadius: "60px",
    transition: "0.3s ease",
    border: "1px solid #C8D3E0",
    "&.active": {
      background: "#FF682A",
      border: "1px solid #FF682A",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "16px 20px",
    },
  },
  flipCard: {
    background: "#fff",
    borderRadius: "24px",
    overflow: "hidden",
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  flipCardLeft: {
    width: "50%",
    paddingTop: "40px",
    display: "flex",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      paddingTop: "0px",
    },
  },
  flipCardRight: {
    padding: "40px",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "20px",
      gap: "20px",
    },
  },
  flipCardRightHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointers: {
    display: "flex",
    gap: "40px",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  growingBusiness: {
    // backgroundImage: `url(${growingBussinessBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "80px",
    position: "relative",
    "& .header": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "100%",
      },
    },
  },
  broadcastContainerInner: {
    gap: "30px",
    width: "100%",
    display: "flex",
    padding: "0 8rem 0rem 8rem",
    paddingBottom: "10px !important",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "& swiper-wrapper": {
      alignItems: "stretch !important",
    },

    "& $featureContainer": {
      width: "31%",
      height: "auto  !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px !important",
      paddingBottom: "10px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      paddingLeft: "23rem !important",
      paddingRight: "23rem !important",
    },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 16px #C1D7DB66",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },
  detailSection: {
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${benefitSectionBg})`,
    // "&.section3": {
    //   background: "linear-gradient(180deg, #001742 0%, #002C7E 100%)",
    // },
    // "&.section1": {
    //   background: "transparent",
    // },
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column-reverse",
      gap: "20px",
    },
    "&.detailCard3": {
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column-reverse",
        gap: "32px",
      },
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "auto",
    "&.card2": {
      width: "48%",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${swiperCardBg})`,
      backgroundSize: "contain",
      backgroundPosition: "top",
      padding: "20px 20px 0",
      flexWrap: "wrap",
      flexDirection: "row",
      borderRadius: "16px 16px 0 0",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
        padding: "0",
        backgroundImage: "none",
        gap: "15px",
        marginTop: "24px",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  swiperCard: {
    background: "#fff",
    boxShadow: "0 4px 26.1px 0 #F5C5B9",
    width: "48%",
    padding: "32px 24px",
    borderRadius: "16px",
    height: "250px",
    overflow: "hidden",
    transition: "0.5s ease",
    "@media only screen and (max-width: 600px)": {
       boxShadow:'2px 2px 16px 0px #F5C5B9'
     },
    "& .mainCard": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      gap: "24px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
        gap: "15px",
        justifyContent: "flex-start",
      },
    },
    "& .mainCardHeader": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      gap: "16px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    "& .hoverCard": {
      bottom: "-50%",
      height: "-webkit-fill-available",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      position: "relative",
      transition: "0.5s ease",
      visibility: "hidden",
      opacity: "0",
      "@media only screen and (max-width: 600px)": {
        display: "none",
      },
    },
    // "&:hover": {
    //   "& .mainCard": {
    //     top: "-150%",
    //     visibility: "hidden",
    //     opacity: "0",
    //   },
    //   "& .hoverCard": {
    //     bottom: "100%",
    //     visibility: "visible",
    //     opacity: "1",
    //   },
    // },
    "@media only screen and (max-width: 600px)": {
      width: "47%",
      padding: "15px",
      "&:hover": {
        "& .hoverCard": {
          display: "none !important",
        },
        "& .mainCard": {
          top: "0% !important",
          visibility: "visible !important",
          opacity: "1 !important",
        },
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "transparent",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.30)",
    },
    "&:before": {
      borderRadius: "0 0 4px 4px",
      content: '""',
      position: "absolute",
      background: "linear-gradient(180deg,#B1DBFF 0%, #fff 0%, #0089FF 100% )",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
}));

const EmailIntegration = () => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });
  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track?.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "ActiveCampaign CRM",
    "EngageBay CRM",
    "Brevo CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is a user-friendly, all-in-one CRM solution designed to empower sales teams and SMEs with powerful email integration capabilities. It stands out for its seamless Gmail and Outlook integration, intuitive interface, and robust features tailored for businesses of all sizes.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "All-in-one CRM system",
          desc: "Accelerate sales operations, manage leads and opportunities, and streamline communications with a unified CRM platform built for growing businesses.",
        },
        {
          title: "Sales management",
          desc: "Simplify and organise your sales pipeline. Create multiple pipelines and stages, visualise deals, and forecast sales accurately. Monitor sales activities in real time for greater productivity and faster deal closure.",
        },
        {
          title: "Lead management",
          desc: "Automate lead capture from emails, forms, and messages. Eliminate manual data entry, auto-assign leads, and send personalised follow-ups—ensuring every opportunity gets attention.",
        },
        {
          title: "Omnichannel CRM solution",
          desc: "Integrates with messaging platforms, email, calling tools, and more. Manage all customer communications from one place, offering a truly omnichannel CRM experience.",
        },
        {
          title: "Workflow automation",
          desc: "Boost productivity by automating repetitive tasks, including emails and messages. Set up triggers to assign tickets, send follow-ups, and handle routine actions effortlessly.",
        },
        {
          title: "Integrated with WhatsApp",
          desc: "Talk to customers and prospects instantly with native WhatsApp CRM integration. Capture leads, respond to inquiries, and broadcast promotions for seamless customer engagement.",
        },
        {
          title: "Intuitive Chrome extension and Outlook add-in",
          desc: "Turn Gmail and Outlook into CRM hubs. Manage contacts, log emails, and complete CRM tasks directly from your inbox with the Chrome extension and Outlook add-in.",
        },
        {
          title: "Get started",
          desc: "",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is a popular choice known for its robust marketing features and user-friendly interface. It offers a comprehensive suite of tools for sales, marketing, and customer service.",
      img: compareItemImg2,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Comprehensive toolkit",
          desc: "Includes forms, landing pages, deal pipelines, and website tracking for end-to-end funnel management.",
        },
        {
          title: "Feature-rich and easy to use",
          desc: "A modern, easy-to-use interface packed with built-in tools for sales and marketing teams.",
        },
        {
          title: "Integrated builders",
          desc: "Built-in form and landing page builders streamline contact acquisition and follow-up.",
        },
        {
          title: "Scalable plans",
          desc: "Grows with your business—paid options unlock more automation and customisation.",
        },
      ],
    },
    {
      title: "ActiveCampaign CRM",
      desc: "ActiveCampaign offers powerful marketing automation capabilities alongside robust CRM features, ideal for businesses focused on nurturing leads through targeted email campaigns.",
      img: compareItemImg3,
      alt: "ActiveCampaign CRM",
      features: [
        {
          title: "Sophisticated marketing automation",
          desc: "Automate communications with a wide range of triggers and actions to move leads through the funnel.",
        },
        {
          title: "Deal management with pipeline visualisation",
          desc: "Organise and automate pipeline stages; view sales progress at a glance.",
        },
        {
          title: "Win probability",
          desc: "Calculate the probability of deal closure to help sales teams prioritise efforts.",
        },
        {
          title: "Separation of email marketing and CRM pricing",
          desc: "Choose plans based on your focus—CRM or email marketing.",
        },
        {
          title: "Omnichannel communication",
          desc: "Manage customer interactions across email, SMS, and chat from a single platform.",
        },
      ],
    },
    {
      title: "EngageBay CRM",
      desc: "EngageBay offers an all-in-one marketing, sales, and support solution with a strong focus on affordability and ease of use, making it particularly attractive for small to medium-sized businesses.",
      img: compareItemImg4,
      alt: "EngageBay CRM",
      features: [
        {
          title: "Intuitive user interface",
          desc: "A clean, user-friendly platform that's easy to set up and operate.",
        },
        {
          title: "Contact segmentation",
          desc: "Segment contacts with advanced filters to personalise communications.",
        },
        {
          title: "Automated contact scoring",
          desc: "Assign scores and automate follow-ups with trigger-based workflows.",
        },
        {
          title: "Affordable all-in-one pricing",
          desc: "Access bundled CRM and marketing tools at a lower cost than most competitors.",
        },
        {
          title: "Free plan available",
          desc: "Start with a generous free plan including basic CRM and email features.",
        },
      ],
    },
    {
      title: "Brevo CRM (Previously Sendinblue)",
      desc: "Brevo, formerly known as Sendinblue, offers a powerful combination of email marketing and CRM capabilities, with a focus on helping businesses create more personalised customer journeys.",
      img: compareItemImg5,
      alt: "Brevo CRM (Previously Sendinblue)",
      features: [
        {
          title: "Free plan with unlimited contacts",
          desc: "Manage unlimited contacts and enjoy basic CRM features at no cost.",
        },
        {
          title: "User-friendly interface",
          desc: "Clean, easy-to-navigate dashboards for email marketing and CRM.",
        },
        {
          title: "Advanced email automation",
          desc: "Build sophisticated automations with multiple entry points and custom conditions.",
        },
        {
          title: "Dedicated Sales CRM app",
          desc: "Utilise Brevo's free CRM app for advanced pipeline and deal management.",
        },
        {
          title: "Scalable paid plans",
          desc: "Access higher email sending limits and premium features as your business grows.",
        },
      ],
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "What is CRM email integration?",
      answer: (
        <>
          CRM email integration is the seamless connection between your email
          service (like Gmail or Outlook) and your Customer Relationship
          Management (CRM) software. It allows you to manage all your customer
          communications, track interactions, and access customer data directly
          from your email interface or within your CRM. Apart from Gmail /
          Outlook integration, Pepper Cloud CRM also offers SMTP.
        </>
      ),
    },
    {
      question: "How does email integration improve sales productivity?",
      answer: (
        <>
          Email integration eliminates the need to switch between platforms,
          automates data entry, provides a complete view of customer
          interactions, enables you to log tasks and activities, and allows for
          quicker follow-ups, all of which contribute to increased sales
          productivity.
        </>
      ),
    },
    {
      question: "Is my email data secure when using CRM email integration?",
      answer: (
        <>
          Yes, Pepper Cloud CRM prioritises data security. They use encryption,
          secure servers, and comply with data protection regulations to ensure
          your email and customer data remains protected. On the other hand,
          Pepper Cloud CRM also offers SMTP through which you can send and
          receive emails without any security risks or the hassle of integrating
          with personal email IDs.
        </>
      ),
    },
    {
      question: "Can I access my CRM emails on mobile devices?",
      answer: (
        <>
          Yes, Pepper Cloud mobile CRM allows you to access your emails and CRM
          data on the go, ensuring you stay connected with your customers
          wherever you are. You can download mobile CRM here: For Android and
          for iOS.
        </>
      ),
    },
    {
      question: "Can I send bulk emails through my CRM?",
      answer: (
        <>
          Yes, you can send bulk emails to segmented lists of leads or contacts.
          This feature is particularly useful for email marketing campaigns or
          sending updates to multiple clients at once.
        </>
      ),
    },
    {
      question:
        "How do I ensure my emails don't end up in spam folders when sent through CRM?",
      answer: (
        <>
          To improve deliverability, use the email integrated CRM that follows
          email best practices, maintain clean email lists, and personalise your
          emails.
        </>
      ),
    },
    {
      question: "Can I automate emails with CRM email integration?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers email automation features that allow you
          to set up triggers and conditions to send emails based on certain
          actions or time delays.
        </>
      ),
    },
    {
      question:
        "How can real estate agencies benefit from CRM email integration?",
      answer: (
        <>
          Real estate agencies can use CRM email integration to automatically
          track property enquiries, send bulk updates about new listings, manage
          viewing schedules, and set up automated follow-ups for property
          viewings and document submissions. It helps maintain organised
          communication throughout the entire property sale or rental process.
        </>
      ),
    },
    {
      question:
        "What advantages does CRM email integration offer for financial services?",
      answer: (
        <>
          Financial services can benefit from an email-integrated CRM.
          Businesses can automatically achieve client communications for
          compliance, sending personalised portfolio updates, secure document
          sharing, and streamlined client onboarding. It helps maintain
          regulatory compliance while delivering personalised service to
          clients.
        </>
      ),
    },
    {
      question:
        "How does CRM email integration enhance healthcare service delivery?",
      answer: (
        <>
          Healthcare providers can use email integration features in a CRM to
          send automated appointment reminders, deliver test reports, manage
          specialist referrals, and securely maintain communication records. It
          helps improve patient care coordination while ensuring regulatory
          compliance.
        </>
      ),
    },
    {
      question:
        "What features make CRM email integration valuable for e-commerce businesses?",
      answer: (
        <>
          E-commerce businesses can leverage an CRM email integration to send
          automated order updates, deliver personalised product recommendations
          based on purchase history, manage customer support enquiries
          efficiently, and run automated abandoned cart recovery campaigns.
        </>
      ),
    },
    {
      question:
        "How does CRM email integration support sales team productivity?",
      answer: (
        <>
          Sales teams can boost productivity by accessing customer data directly
          from their email inbox within the CRM, automating follow-ups, tracking
          email interactions, and managing their pipeline without switching
          between applications. This creates a more efficient workflow and
          ensures no leads fall through the cracks.
        </>
      ),
    },
  ];

  const swiperCards = [
    {
      icon: swiperIcon1,
      heading: "Unified platform",
      contentOne:
        "Access your email communication, activities, and related data from a single platform.",
    },
    {
      icon: swiperIcon2,
      heading: "Personalised emails",
      contentOne:
        "Leverage CRM email integration to understand customer needs and tailor every email.",
    },
    {
      icon: swiperIcon3,
      heading: "Sales productivity",
      contentOne:
        "Auto-sync multiple email inboxes with your CRM—run your business from anywhere.",
    },
    {
      icon: swiperIcon4,
      heading: "Sales automation",
      contentOne:
        "Accelerate your sales process by automating emails with CRM email integration.",
    },
  ];

  const growingList = [
    {
      icon: growingIcon1,
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      heading: "Multi-email integration",
      text: "Integrate Gmail and Outlook with your CRM and access multiple email inboxes from a centralised platform.",
    },
    {
      icon: growingIcon2,
      background: "linear-gradient(180deg, #783CA8 0%, #31114B 100%)",
      heading: "Sync in minutes",
      text: "Automatically log emails, update contacts, sync calendar events, and more with CRM email integration.",
    },
    {
      icon: growingIcon3,
      background: "linear-gradient(180deg, #014957 0%, #028BA6 100%)",
      heading: "Manage sales activities",
      text: "Track, assign, and manage tasks and events directly from Gmail and Outlook inboxes with easy-to-use extensions.",
    },
    {
      icon: growingIcon4,
      background: "linear-gradient(180deg, #09939A 0%, #783CA8 100%)",
      heading: "360-degree customer data",
      text: "Gain deep insights into email history and preferences to easily convert leads into customers.",
    },
    {
      icon: growingIcon5,
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
      heading: "Bulk emailing",
      text: "Send targeted promotions, share product updates, and broadcast deals to multiple contacts at once.",
    },
    {
      icon: growingIcon6,
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      heading: "Email extensions",
      text: "Log emails directly to CRM and manage them from within Gmail or Outlook using Chrome and Outlook extensions.",
    },
    {
      icon: growingIcon7,
      background: "linear-gradient(180deg, #2788E7 0%, #783CA8 100%)",
      heading: "Automated email workflows",
      text: "Set up triggers like form submissions and automate sending of follow-up emails, reminders, and more.",
    },
  ];
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };
  const flipCards = [
    {
      tab: "Gmail integration",
      icon: tabIcon2,
      img: flipImg2,
      alt: "Connect Outlook to CRM platform",
      heading: "Effortless Gmail integration",
      desc: "Manage your emails seamlessly with powerful CRM Gmail integration. It empowers you to access CRM features directly from your Gmail inbox with CRM chrome extension.",
      points: [
        {
          heading: "Direct access",
          desc: "Manage your emails directly within the Pepper Cloud CRM system, without switching apps.",
        },
        {
          heading: "Seamless workflow",
          desc: "You can compose, send, and receive emails without ever leaving the CRM platform.",
        },
        {
          heading: "Efficiency boost",
          desc: "Save time by eliminating the need to switch between Gmail and your CRM.",
        },
      ],
    },
    {
      tab: "Outlook integration",
      icon: tabIcon3,
      img: flipImg3,
      alt: "Best CRM for Office 365 users",
      heading: "Streamlined Outlook integration",
      desc: "Maximise your productivity with the best CRM for Office 365. Experience enhanced flexibility and smooth synchronisation.",
      points: [
        {
          heading: "Unified inbox",
          desc: "Capture your Outlook emails and contacts into the Pepper Cloud CRM platform with just a click.",
        },
        {
          heading: "Centralised management",
          desc: "Handle all your email-related tasks from within the CRM, without switching apps.",
        },
        {
          heading: "Complete customer view",
          desc: "Access comprehensive customer data alongside your Outlook emails.",
        },
      ],
    },
    {
      tab: "SMTP email integration",
      icon: tabIcon1,
      img: flipImg1,
      alt: "CRM Chrome extension for productivity",
      heading: "Secure SMTP email integration",
      desc: "Use custom SMTP integration to send and receive emails from CRM without using personal email IDs.",
      points: [
        {
          heading: "Data security",
          desc: "Empower your team with a secure way to send emails and protect sensitive customer data.",
        },
        {
          heading: "Automated workflows",
          desc: "With SMTP email and CRM integration, you can automate email workflows and save time.",
        },
        {
          heading: "Increased deliverability",
          desc: "Boost the likelihood of your emails reaching recipients’ inboxes, and not spam.",
        },
      ],
    },
  ];
  /* Tweak these constants if you want a stronger/weaker stack effect */
  const STACK_SPACING_PX = 30;
  const SCALE_STEP = 0.02;
  const MAX_SCALE_REDUCTION = 0.08;

  const getOpacity = (offset) => {
    if (offset === 0) return 1;
    if (Math.abs(offset) === 1) return 0.6;
    return 0.4;
  };

  const getZIndex = (offset) => {
    // max z-index = 10
    return 10 - Math.abs(offset);
  };
  return (
    <main>
      <SEO
        title={
          "Seamless CRM Email Integration for Gmail, Outlook & Office 365 Email | Pepper Cloud"
        }
        pathname={"https://peppercloud.com/whatsApp-CRM-for-customer-service"}
        keywords="Gmail integration, Outlook integration, best CRM for Office 365, CRM chrome extension, email integration, crm system integration"
        description={
          " Experience unified email management with CRM Gmail integration, Outlook syncing, and secure SMTP. Track emails, automate follow-ups, log activities, and access customer data instantly with Pepper Cloud CRM."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        scripts={[`gtag('event', 'whatsapp_support_crm_generate_lead', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What are the benefits of WhatsApp CRM for customer service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
                },
              },
              {
                "@type": "Question",
                name: "What are the top 3 features which make our CRM ideal for customer support on WhatsApp?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our CRM offers a smart ticketing system with automation rules, a multi-channel inbox with complete customer history, and real-time agent availability and assignment, making it ideal for customer support on WhatsApp.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
                },
              },
              {
                "@type": "Question",
                name: "Can WhatsApp CRM work for small and medium businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. WhatsApp CRM is designed to scale with your business. SMEs benefit from automation, ticket management, and customer history features without needing large support teams.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is customer data in a WhatsApp CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
                },
              },
              {
                "@type": "Question",
                name: "Does WhatsApp CRM integrate with other business tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM improve customer retention?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
                },
              },
              {
                "@type": "Question",
                name: "What role does AI play in WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
                },
              },
              {
                "@type": "Question",
                name: "Can multiple team members manage the same customer conversation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. With collaboration tools inside WhatsApp CRM, multiple agents can view, comment, and resolve queries together without losing context or duplicating work.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM support omnichannel communication?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Seamless CRM email integration
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Streamline your email workflow with robust CRM email
                integration. Seamlessly send, manage, and track emails from
                within a single, centralised platform.
              </motion.p>
              <div className={classes.listContainer}>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white  font-18">
                    Unified inbox
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Real-time email sync
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Email automation
                  </p>
                </motion.div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className={classes.aiSectionRight}>
              <LazyImage
                source={heroSectionImg}
                width="100%"
                alt="CRM software with Gmail integration"
              />
            </div>
          </div>
        </div>
      </section>
      <ClientScroll
        {...clientScrollData}
        // background={topIndustiesBg}
        darkLayout={false}
      />
      <section className={classes.flipSection}>
        <div className="container">
          <div className="centerContainer">
            <h2 className="font-56 font-wix-medium font-white">
              Bring email inbox and CRM together with just a click
            </h2>
            <div className={classes.tabs}>
              {flipCards.map((tab, index) => (
                <div
                  className={clsx(
                    classes.tab,
                    activeIndex === index && "active"
                  )}
                  onClick={() => setActiveIndex(index)}
                >
                  <img src={tab.icon} alt={tab.alt} />
                  <p className="font-20 font-wix-medium font-white">
                    {tab.tab}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div
            className="stackWrapper"
            style={{
              position: "relative",
              width: "100%",
            }}
          >
            {flipCards.map((card, index) => {
              const offset = index - activeIndex;
              const translateY = offset * STACK_SPACING_PX;
              const scale =
                1 -
                Math.min(Math.abs(offset) * SCALE_STEP, MAX_SCALE_REDUCTION);

              return (
                <div
                  key={card.tab}
                  className={classes.flipCard}
                  // apply your original flipCard styles (unchanged) and add absolute + transition + transform via inline
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    transform: `translateX(-50%) translateY(${translateY}px) scale(${scale})`,
                    transition:
                      "transform 0.45s cubic-bezier(.2,.9,.2,1), opacity 0.35s",
                    zIndex: getZIndex(offset),
                    opacity: getOpacity(offset),
                    pointerEvents: index === activeIndex ? "auto" : "none",
                  }}
                  aria-hidden={index === activeIndex ? "false" : "true"}
                >
                  <div className={classes.flipCardLeft}>
                    {/* keep your LazyImage usage */}
                    <LazyImage source={card.img} width={"100%"} />
                  </div>

                  <div className={classes.flipCardRight}>
                    <div className={classes.flipCardRightHeader}>
                      <h2
                        className="font-40 font-wix-medium color-black1"
                        style={{ margin: 0 }}
                      >
                        {card.heading}
                      </h2>
                      <p
                        className="font-18 font-wix-medium"
                        style={{ color: "#304358", margin: 0 }}
                      >
                        {card.desc}
                      </p>
                    </div>

                    <div className={classes.flipCardPointers}>
                      {card.points.map((point, idx) => (
                        <div key={idx} className={classes.flipCardPointer}>
                          <p
                            className="font-18 font-wix-semibold color-black1"
                            style={{ margin: 0 }}
                          >
                            {point.heading}
                          </p>
                          <p
                            className="font-16 font-wix-regular color-black1"
                            style={{ margin: 0 }}
                          >
                            {point.desc}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Why is Pepper Cloud the best  CRM email integration
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 3.3,
              centeredSlides: false,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide
              className={classes.featureContainer}
              style={{ background: feature.background }}
            >
              <LazyImage
                source={feature.icon}
                alt={"WhatsApp CRM for customer service"}
                className={classes.featureIcon}
                // alt={listItem.alt}
              />
              <p className="font-wix-semibold font-24 font-white">
                {feature.heading}
              </p>
              <p className="font-wix-mediu font-18 font-white">
                {feature.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
      </section>
      <section className={classes.detailSection}>
        <div className="container">
          <div className={classes.detailCard}>
            <div className={clsx(classes.detailCardLeft, "card2")}>
              {swiperCards.map((card) => (
                <div
                  className={classes.swiperCard}
                  style={{ background: card.gradientOne }}
                >
                  <div className="mainCard">
                    <div className="mainCardHeader">
                      <img src={card.icon} />
                      <h4 className="font-20 color-black1 font-wix-semibold">
                        {card.heading}
                      </h4>
                    </div>
                    <p className="font-16 color-black1 font-wix-regular">
                      {card.contentOne}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className={classes.detailCardRight}>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                Benefits of CRM email integration
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black1"
              >
                Unlock faster growth and smarter selling with powerful CRM email
                integration. Centralise customer data, personalise every
                interaction, and eliminate time-wasting tasks with automated
                syncing and logging.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo-2 logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Top 5 CRM software with email integration in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"CRM email integration - Frequently asked questions (FAQs)"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Email integration to supercharge your sales
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default EmailIntegration;
